import React from "react";
import {
  Box,
  Button,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Close, DeleteOutline, Edit, Save } from "@mui/icons-material";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";

interface ServiceTableSectionProps {
  data: any[];
  editingRowId: number | null;
  filterOption: any;
  setFilterOption: any;
  onAddNew: () => void;
  onEdit: (id: number) => void;
  onSave: (id: number) => void;
  onCancel: () => void;
  onChange: (id: number, field: string, value: string) => void;
  onDelete: (id: number) => void;
}

const tableHeadings: TableHeading[] = [
  { label: "Service Name", align: "left" },
  { label: "Short Code", align: "left" },
  { label: "Detail", align: "left" },
  { label: "Appears in", align: "left" },
  { label: "Actions", align: "center" },
];

const textFieldSx = {
  width: 230,
  "& .MuiInputBase-root": {
    height: 28,
  },
  "& .MuiInputBase-input": {
    padding: "2px 8px",
    fontSize: "13px",
  },
  "& .MuiInputLabel-root": {
    fontSize: "13px",
  },
};

const textFieldSx1 = {
  width: 150,
  "& .MuiInputBase-root": {
    height: 28,
  },
  "& .MuiInputBase-input": {
    padding: "2px 8px",
    fontSize: "13px",
  },
  "& .MuiInputLabel-root": {
    fontSize: "13px",
  },
};

const ServiceTableSection = ({
  data,
  editingRowId,
  filterOption,
  setFilterOption,
  onAddNew,
  onEdit,
  onSave,
  onCancel,
  onChange,
  onDelete,
}: ServiceTableSectionProps) => {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        border: "1px solid #d1cfcf",
        borderRadius: "5px",
        overflow: "hidden",
        mt: 2,
      }}
    >
      <Box sx={{ p: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
            Services
          </Typography>
          {/* <Button variant="contained" size="small" onClick={onAddNew}>
            Add New
          </Button> */}
        </Box>
      </Box>

      <TableDesign
        tableHeadings={tableHeadings}
        tableHeadColor="#02906f"
        cellColor="#fff"
        pagination={null}
        isLoader={false}
        stickyHeader={true}
        filterOption={filterOption}
        setFilterOption={setFilterOption}
        extraCSS={{ height: "100%" }}
      >
        {data.map((row: any, i: number) => (
          <TableRow key={i} sx={{ height: 36 }}>
            <TableCell>
              {editingRowId === row.id ? (
                <TextField
                  size="small"
                  value={row.name}
                  onChange={(e) => onChange(row.id, "name", e.target.value)}
                  sx={textFieldSx}
                />
              ) : (
                row.name
              )}
            </TableCell>
               <TableCell>
              {editingRowId === row.id ? (
                <TextField 
                  size="small"
                  value={row.short_code}
                  disabled
                  sx={textFieldSx1}
                />
              ) : (
                row.short_code
              )}
            </TableCell>
            <TableCell>
              {editingRowId === row.id ? (
                <TextField
                  size="small"
                  fullWidth
                  value={row.description}
                  disabled
                  sx={textFieldSx}
                />
              ) : (
                row.description
              )}
            </TableCell>

            <TableCell>{row.appears_in}</TableCell>

            <TableCell align="center">
              {row?.is_editable && (
                <>
                  {editingRowId === row.id ? (
                    <>
                      <IconButton color="success" onClick={() => onSave(row.id)}>
                        <Save fontSize="small" />
                      </IconButton>
                      <IconButton color="default" onClick={onCancel}>
                        <Close fontSize="small" />
                      </IconButton>
                    </>
                  ) : (
                    <IconButton color="primary" onClick={() => onEdit(row.id)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  )}
                </>
              )}

              {/* {row?.is_deletable && (
                <IconButton color="error" onClick={() => onDelete(row.id)}>
                  <DeleteOutline fontSize="small" />
                </IconButton>
              )} */}
            </TableCell>
          </TableRow>
        ))}
      </TableDesign>
    </Box>
  );
};

export default ServiceTableSection;
